import React, { useState } from 'react';
import { FiPackage, FiCheckCircle } from 'react-icons/fi';

// Se conserva la apariencia del buscador original y se agrega seleccion multiple.
export default function MultiProductPicker({ products, onAdd, disabled = false, renderMeta, renderPrice }) {
  const [selected, setSelected] = useState({});
  const [quantities, setQuantities] = useState({});
  const [lastRemoved, setLastRemoved] = useState(null);
  const undoRemoval = () => {
    if (!lastRemoved) return;
    onAdd([{ product: lastRemoved.product, quantity: lastRemoved.quantity }]);
    setSelected(prev => ({ ...prev, [lastRemoved.product.id]: { product: lastRemoved.product, quantity: String(lastRemoved.quantity) } }));
    setQuantities(prev => ({ ...prev, [lastRemoved.product.id]: String(lastRemoved.quantity) }));
    setLastRemoved(null);
  };
  const toggle = (product) => {
    if (disabled) return;
    const existing = selected[product.id];
    const qty = Number(quantities[product.id] ?? '1');
    if (!existing && (!Number.isFinite(qty) || qty <= 0)) return;
    onAdd([{ product, quantity: existing ? -Number(existing.quantity) : qty }]);
    setLastRemoved(existing ? { product, quantity: Number(existing.quantity) } : null);
    setSelected(prev => {
      const next = { ...prev };
      if (next[product.id]) delete next[product.id];
      else next[product.id] = { product, quantity: String(qty) };
      return next;
    });
  };
  const updateQuantity = (product, value) => {
    setQuantities(prev => ({ ...prev, [product.id]: value }));
    const previous = Number(selected[product.id]?.quantity ?? 0);
    const next = Number(value);
    // Seleccionar cantidad ya agrega el producto; Enter solo cierra el buscador.
    if (value !== '' && Number.isFinite(next) && next > 0 && next !== previous) {
      onAdd([{ product, quantity: selected[product.id] ? next - previous : next }]);
      setSelected(prev => ({ ...prev, [product.id]: { product, quantity: value } }));
    }
  };
  return <>
    {lastRemoved && (
      <div role="status" aria-live="polite" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, padding: '9px 12px', marginBottom: 8, background: '#f7f0fa', border: '1px solid #d8b7e1', borderRadius: 8, fontSize: 13, color: '#4b2456' }}>
        <span style={{ minWidth: 0 }}>Producto quitado: <strong>{lastRemoved.product.nombreProducto}</strong></span>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
          <button type="button" onClick={undoRemoval} style={{ border: '1px solid #8c299f', borderRadius: 6, padding: '5px 10px', background: '#fff', color: '#7c248c', fontWeight: 700, cursor: 'pointer' }}>Deshacer</button>
          <button type="button" onClick={() => setLastRemoved(null)} aria-label="Cerrar aviso" style={{ border: 0, background: 'transparent', cursor: 'pointer', color: '#6b7280', fontSize: 18 }}>×</button>
        </div>
      </div>
    )}
    {products.map(product => {
      const active = Boolean(selected[product.id]);
      return <div key={product.id} className="product-dropdown-item" role="checkbox" aria-checked={active} tabIndex={disabled ? -1 : 0}
        onClick={e => { e.stopPropagation(); toggle(product); }}
        onKeyDown={e => { if (e.target === e.currentTarget && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); toggle(product); } }}
        style={{ display: 'flex', alignItems: 'center', gap: 12, cursor: disabled ? 'default' : 'pointer', backgroundColor: active ? '#f1f8f2' : undefined, borderLeft: active ? '3px solid #8c299f' : '3px solid transparent' }}>
        <div className="product-dropdown-icon"><FiPackage size={20} /></div>
        <div className="product-dropdown-info" style={{ flex: 1, minWidth: 0 }}>
          <div className="product-dropdown-name">{product.nombreProducto}</div>
          <div className="product-dropdown-meta">{renderMeta ? renderMeta(product) : <span className="meta-stock">Stock: {product.stock ?? 0}</span>}</div>
        </div>
        {renderPrice && <div className="product-dropdown-price">{renderPrice(product)}</div>}
        <div onClick={e => e.stopPropagation()} onKeyDown={e => e.stopPropagation()} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <input type="number" min="0.001" step="any" aria-label={`Cantidad de ${product.nombreProducto}`}
            style={{ width: 72, padding: '7px 8px', borderRadius: 7, border: '1px solid #d1d5db' }}
            disabled={disabled} value={quantities[product.id] ?? '1'}
            onChange={e => updateQuantity(product, e.target.value)} onBlur={() => { if (!(Number(quantities[product.id] ?? '1') > 0)) setQuantities(prev => ({ ...prev, [product.id]: selected[product.id]?.quantity ?? '1' })); }} />
        </div>
        <span aria-label={active ? 'Producto agregado' : 'Producto no agregado'} style={{ width: 22, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: '#16803c' }}>
          {active && <FiCheckCircle size={21} />}
        </span>
      </div>;
    })}
  </>;
}
